import type { AuthAdapter } from './types';

export type * from './types';

/**
 * The active auth adapter. `main.tsx` installs either the Better Auth adapter or the in-memory mock
 * (VITE_MOCK_API=1) before the app renders, so the other one is never bundled/loaded.
 */
let adapter: AuthAdapter | null = null;

export function setAuthAdapter(a: AuthAdapter) {
  adapter = a;
}

export const auth: AuthAdapter = new Proxy({} as AuthAdapter, {
  get(_t, prop: keyof AuthAdapter) {
    if (!adapter) throw new Error('Auth adapter not initialised');
    const v = adapter[prop];
    return typeof v === 'function' ? (v as (...a: unknown[]) => unknown).bind(adapter) : v;
  },
});
